/**
 * @prettier
 * @flow
 */
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

export function useAction(action: Function, deps?: Array<any>): Function {
    const dispatch = useDispatch();
    return useMemo(
        () => {
            return bindActionCreators(action, dispatch);
        },
        deps ? [dispatch, ...deps] : [dispatch]
    );
}
